import type { PageResponseType, ResponseType } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = 'api/v1';

/**
 * @description 物料收料单
 */
export const iqcInspectReceiveBillApi = {
  list(params: {
    date?: string[];
    status?: string;
    rowStatus?: string;
    billNo?: string;
    materialNumber?: string;
    materialName?: string;
  }): PageResponseType {
    return request({
      url: prefix + '/receiveBill/list',
      method: 'GET',
      params,
    });
  },

  /**
   * @description 下推
   */
  push(data: { billNo: string; entryIds: number[]; materials: string[] }): ResponseType {
    return request({
      url: prefix + '/receiveBill/push',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 加急
   */
  urgent(data: { entryIds: string[]; isRushOrder: boolean; expectFinishAt: number | null }): ResponseType {
    return request({
      url: prefix + '/receiveBill/urgent',
      method: 'POST',
      data,
    });
  },
};
